{
  "en": {
    "Sorry, I couldn't reach the server. Please try again.": "Sorry, I couldn't reach the server. Please try again.",
    "Tap to chat": "Tap to chat",
    "Unmute": "Unmute",
    "Please wait a few minutes before sending again.": "Please wait a few minutes before sending again.",
    "You could also ask": "You could also ask",
    "AI guide · {business}": "AI guide · {business}",
    "Made with Mugam.site": "Made with Mugam.site",
    "Thanks! We'll get back to you.": "Thanks! We'll get back to you.",
    "Choose a guide": "Choose a guide",
    "Speak your question": "Speak your question",
    "Thinking…": "Thinking…",
    "Your details go to {business}.": "Your details go to {business}.",
    "Please fill in {field}.": "Please fill in {field}.",
    "Couldn't send. Please try again.": "Couldn't send. Please try again.",
    "Hide suggested questions": "Hide suggested questions",
    "Mute": "Mute",
    "the site owner": "the site owner",
    "Please wait {seconds} seconds before asking another question.": "Please wait {seconds} seconds before asking another question.",
    "Close chat": "Close chat",
    "Show suggested questions": "Show suggested questions",
    "Show {name}": "Show {name}",
    "Show me on the page →": "Show me on the page →",
    "You've explored these questions. Ask anything below.": "You've explored these questions. Ask anything below.",
    "Ask {name} anything…": "Ask {name} anything…",
    "Your question": "Your question",
    "Listening…": "Listening…",
    "Try a question": "Try a question",
    "Questions": "Questions",
    "Chat with {name}": "Chat with {name}",
    "Hide {name}": "Hide {name}",
    "Typing": "Typing",
    "Suggested questions": "Suggested questions",
    "Send": "Send",
    "Sending…": "Sending…",
    "Speaking": "Speaking"
  },
  "fr": {
    "Sorry, I couldn't reach the server. Please try again.": "Désolé, impossible de joindre le serveur. Veuillez réessayer.",
    "Tap to chat": "Touchez pour discuter",
    "Unmute": "Réactiver le son",
    "Please wait a few minutes before sending again.": "Veuillez patienter quelques minutes avant de renvoyer.",
    "You could also ask": "Vous pourriez aussi demander",
    "AI guide · {business}": "Guide IA · {business}",
    "Made with Mugam.site": "Réalisé avec Mugam.site",
    "Thanks! We'll get back to you.": "Merci ! Nous vous recontacterons.",
    "Choose a guide": "Choisissez un guide",
    "Speak your question": "Posez votre question à voix haute",
    "Thinking…": "Réflexion…",
    "Your details go to {business}.": "Vos coordonnées seront transmises à {business}.",
    "Please fill in {field}.": "Veuillez renseigner {field}.",
    "Couldn't send. Please try again.": "Échec de l'envoi. Veuillez réessayer.",
    "Hide suggested questions": "Masquer les questions suggérées",
    "Mute": "Muet",
    "the site owner": "le propriétaire du site",
    "Please wait {seconds} seconds before asking another question.": "Veuillez patienter {seconds} secondes avant de poser une autre question.",
    "Close chat": "Fermer le chat",
    "Show suggested questions": "Afficher les questions suggérées",
    "Show {name}": "Afficher {name}",
    "Show me on the page →": "Montrez-moi sur la page →",
    "You've explored these questions. Ask anything below.": "Vous avez consulté ces questions. Posez votre question ci-dessous.",
    "Ask {name} anything…": "Posez n'importe quelle question à {name}…",
    "Your question": "Votre question",
    "Listening…": "Écoute en cours…",
    "Try a question": "Essayez une question",
    "Questions": "Questions",
    "Chat with {name}": "Discuter avec {name}",
    "Hide {name}": "Masquer {name}",
    "Typing": "Saisie en cours",
    "Suggested questions": "Questions suggérées",
    "Send": "Envoyer",
    "Sending…": "Envoi…",
    "Speaking": "En train de parler"
  },
  "it": {
    "Sorry, I couldn't reach the server. Please try again.": "Spiacenti, non sono riuscito a contattare il server. Riprova.",
    "Tap to chat": "Tocca per chattare",
    "Unmute": "Riattiva audio",
    "Please wait a few minutes before sending again.": "Attendi qualche minuto prima di inviare di nuovo.",
    "You could also ask": "Potresti anche chiedere",
    "AI guide · {business}": "Guida IA · {business}",
    "Made with Mugam.site": "Realizzato con Mugam.site",
    "Thanks! We'll get back to you.": "Grazie! Ti risponderemo presto.",
    "Choose a guide": "Scegli una guida",
    "Speak your question": "Pronuncia la tua domanda",
    "Thinking…": "Sto pensando…",
    "Your details go to {business}.": "I tuoi dati vengono inviati a {business}.",
    "Please fill in {field}.": "Compila {field}.",
    "Couldn't send. Please try again.": "Invio non riuscito. Riprova.",
    "Hide suggested questions": "Nascondi domande suggerite",
    "Mute": "Disattiva audio",
    "the site owner": "il proprietario del sito",
    "Please wait {seconds} seconds before asking another question.": "Attendi {seconds} secondi prima di fare un'altra domanda.",
    "Close chat": "Chiudi chat",
    "Show suggested questions": "Mostra le domande suggerite",
    "Show {name}": "Mostra {name}",
    "Show me on the page →": "Mostramelo nella pagina →",
    "You've explored these questions. Ask anything below.": "Hai esplorato queste domande. Chiedi qualsiasi cosa qui sotto.",
    "Ask {name} anything…": "Chiedi qualsiasi cosa a {name}…",
    "Your question": "La tua domanda",
    "Listening…": "In ascolto…",
    "Try a question": "Prova una domanda",
    "Questions": "Domande",
    "Chat with {name}": "Chatta con {name}",
    "Hide {name}": "Nascondi {name}",
    "Typing": "Sta scrivendo",
    "Suggested questions": "Domande suggerite",
    "Send": "Invia",
    "Sending…": "Invio…",
    "Speaking": "Sta parlando"
  },
  "es": {
    "Sorry, I couldn't reach the server. Please try again.": "Lo siento, no pude conectarme con el servidor. Inténtalo de nuevo.",
    "Tap to chat": "Toca para chatear",
    "Unmute": "Activar sonido",
    "Please wait a few minutes before sending again.": "Espera unos minutos antes de volver a enviar.",
    "You could also ask": "También podrías preguntar",
    "AI guide · {business}": "Guía de IA · {business}",
    "Made with Mugam.site": "Creado con Mugam.site",
    "Thanks! We'll get back to you.": "¡Gracias! Te responderemos pronto.",
    "Choose a guide": "Elige un guía",
    "Speak your question": "Di tu pregunta",
    "Thinking…": "Pensando…",
    "Your details go to {business}.": "Tus datos se envían a {business}.",
    "Please fill in {field}.": "Por favor, completa {field}.",
    "Couldn't send. Please try again.": "No se pudo enviar. Inténtalo de nuevo.",
    "Hide suggested questions": "Ocultar preguntas sugeridas",
    "Mute": "Silenciar",
    "the site owner": "el propietario del sitio",
    "Please wait {seconds} seconds before asking another question.": "Por favor, espera {seconds} segundos antes de hacer otra pregunta.",
    "Close chat": "Cerrar chat",
    "Show suggested questions": "Mostrar preguntas sugeridas",
    "Show {name}": "Mostrar {name}",
    "Show me on the page →": "Muéstralo en la página →",
    "You've explored these questions. Ask anything below.": "Has explorado estas preguntas. Pregunta lo que quieras abajo.",
    "Ask {name} anything…": "Pregunta lo que quieras a {name}…",
    "Your question": "Tu pregunta",
    "Listening…": "Escuchando…",
    "Try a question": "Prueba una pregunta",
    "Questions": "Preguntas",
    "Chat with {name}": "Chatear con {name}",
    "Hide {name}": "Ocultar {name}",
    "Typing": "Escribiendo",
    "Suggested questions": "Preguntas sugeridas",
    "Send": "Enviar",
    "Sending…": "Enviando…",
    "Speaking": "Hablando"
  },
  "ru": {
    "Sorry, I couldn't reach the server. Please try again.": "Не удалось подключиться к серверу. Пожалуйста, попробуйте еще раз.",
    "Tap to chat": "Нажмите, чтобы начать чат",
    "Unmute": "Включить звук",
    "Please wait a few minutes before sending again.": "Пожалуйста, подождите несколько минут перед повторной отправкой.",
    "You could also ask": "Вы также можете спросить",
    "AI guide · {business}": "ИИ-помощник · {business}",
    "Made with Mugam.site": "Создано с помощью Mugam.site",
    "Thanks! We'll get back to you.": "Спасибо! Мы свяжемся с вами.",
    "Choose a guide": "Выберите гида",
    "Speak your question": "Произнесите ваш вопрос",
    "Thinking…": "Думаю…",
    "Your details go to {business}.": "Ваши данные передаются {business}.",
    "Please fill in {field}.": "Пожалуйста, заполните {field}.",
    "Couldn't send. Please try again.": "Не удалось отправить. Повторите попытку.",
    "Hide suggested questions": "Скрыть предлагаемые вопросы",
    "Mute": "Без звука",
    "the site owner": "владелец сайта",
    "Please wait {seconds} seconds before asking another question.": "Пожалуйста, подождите {seconds} секунд перед следующим вопросом.",
    "Close chat": "Закрыть чат",
    "Show suggested questions": "Показать предлагаемые вопросы",
    "Show {name}": "Показать {name}",
    "Show me on the page →": "Показать на странице →",
    "You've explored these questions. Ask anything below.": "Вы изучили эти вопросы. Задайте любой ниже.",
    "Ask {name} anything…": "Задайте {name} любой вопрос…",
    "Your question": "Ваш вопрос",
    "Listening…": "Слушаю…",
    "Try a question": "Попробуйте задать вопрос",
    "Questions": "Вопросы",
    "Chat with {name}": "Чат с {name}",
    "Hide {name}": "Скрыть {name}",
    "Typing": "Печатает",
    "Suggested questions": "Предлагаемые вопросы",
    "Send": "Отправить",
    "Sending…": "Отправка…",
    "Speaking": "Говорит"
  }
}